import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=4c5e3c68&"
import script from "./RecentNews.vue?vue&type=script&lang=js&"
export * from "./RecentNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports